import React, { useReducer, useEffect, useState, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  Editing,
  Item,
  ColumnFixing,
  FormItem,
  Paging,
  Pager,
  Export,
  ColumnChooser,
  Toolbar,
} from "devextreme-react/data-grid";
import TagBoxToGrid from "../TagBoxToGrid";
import FileUploader from "devextreme-react/file-uploader";
import * as actions from "../../../actions/dashboard";
import dashboardReducer from "../../../reducers/dashboard";
import { GRID_CONFIG, changesList, hseStatus, GRID_COL_DEF } from "./config";
import { Toast } from "devextreme-react/toast";
import { Button } from "devextreme-react/autocomplete";
import { Popup } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import { getTypeOfFile } from "../../../common/utils";
import Button1 from "devextreme-react/button";
import moment from "moment";
import { ViewFiles } from "../railGrid/utils";
import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
  onDownloadFile
} from "../../../common/utils";
import { checkUploadFilesValid } from "../../../utils/fileValidator";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../../constants/allowedUploadTypes";
import { alert } from "devextreme/ui/dialog";

const initialMocState = {
  id: "",
  existingID: "",
  change: "",
  mocDescription: "",
  mocInitiator: "",
  mocStatus: "",
  userPref: null,
};
const initialState = { mocData: [], peopleList: null };

export default ({ siteId, tierId, isEditable }) => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);
  //const [selectedFiles, setSlectedFiles] = useState(null);
  const { mocData, peopleList, userPref } = state;
  const [isPopupVisible, setIsPopupVisibility] = useState(false);
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [exportFilter, setExportFilter] = useState(0);
  const [isFilePopupVisible, setIsFilePopupVisibility] = useState(false);
  const [popUpImages, setPopUpImages] = useState([]);
  let delList = [];
  const loggedinUser = get("hid");
  const mocDataGridRef = useRef(null);
  const widgetId = "mocWidget";
  const setDeleted = (d) => {
    delList = d;
  };

  const [mocRowData, setmocRowData] = useState(initialMocState);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });

  useEffect(() => {
    let siteInfo = "";
    actions.fetchUsers(dispatch, `tierId=${tierId}` + siteInfo);
    //actions.fetchUsers(dispatch, `siteId=${null}&tierId=${tierId}`);
    actions.fetchMOCData(dispatch, tierId);
  }, []);

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  const onRowUpdated = (data) => {
    let {
      mocid,
      description,
      comments,
      initiator,
      status,
      existingMOCID,
      changes,
      filePath,
      imageName,
      lsImageName = [],
      dueDate,
    } = data.data;
    let formData = new FormData();
    formData.append("mocid", mocid);
    formData.append("TierID", tierId);
    formData.append("changes", changes);
    formData.append("description", description);
    formData.append("comments", comments);
    formData.append("initiator", initiator);
    formData.append("status", status);
    formData.append("ExistingMOCID", existingMOCID);
    formData.append(
      "DueDate",
      dueDate ? moment(dueDate).format("YYYY-MM-DD") : dueDate
    );
    formData.append("filePath", filePath ? filePath : null);
    if (imageName && imageName.length && Array.isArray(imageName)) {
      imageName.forEach((file) => {
        formData.append("files", file);
      });
    }
    formData.append("imageName", lsImageName ? lsImageName.join(",") : null);

    actions.updateMOC(dispatch, formData, tierId);
    actions.fetchMOCData(dispatch, tierId);
    //setSlectedFiles(null);
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Changes Edited Successfully!!",
    });
  };

  const onRowInserted = (data) => {
    let {
      description,
      comments,
      initiator,
      status,
      existingMOCID,
      changes,
      filePath,
      imageName,
      lsImageName = [],
      dueDate,
    } = data.data;
    let formData = new FormData();

    formData.append("mocid", 0);
    formData.append("TierID", tierId);
    formData.append("changes", changes);
    formData.append("description", description);
    formData.append("comments", comments);
    formData.append("initiator", initiator);
    formData.append("status", status);
    formData.append("ExistingMOCID", existingMOCID);
    formData.append(
      "DueDate",
      dueDate ? moment(dueDate).format("YYYY-MM-DD") : dueDate
    );
    formData.append("filePath", filePath ? filePath : null);
    if (imageName && imageName.length && Array.isArray(imageName)) {
      imageName.forEach((file) => {
        formData.append("files", file);
      });
    }
    formData.append(
      "imageName",
      imageName ? lsImageName && lsImageName.join(",") : null
    );
    actions.updateMOC(dispatch, formData, tierId);
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Changes Added Successfully!!",
    });
    //setSlectedFiles(null);
  };

  const onRowRemoved = (data) => {
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Changes Removed Successfully!!",
    });
    actions.deleteMOC(dispatch, data.data.mocid, tierId);
  };

  const toggleFilePopup = () => {
    setIsFilePopupVisibility(!isFilePopupVisible);
  };
  const onEditingStart = () => setDeleted([]);

  const handlers = {
    onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
    onRowInserted: onRowInserted,
    onEditingStart: onEditingStart,
  };

  const cellRender = (data) => {
    return data.value ? (
      <a
        onClick={() => {
          if (data.row.data.lsImageName) {
            setPopUpImages(data.row.data);
            setIsFilePopupVisibility(true);
          }
        }}
      >
        View Attachment
      </a>
    ) : (
      ""
    );
  };

  const cellTemplate = (container, options) => {
    var noBreakSpace = "\u00A0",
      text = (options.value || [])
        .map((element) => {
          return options.column.lookup.calculateCellValue(element);
        })
        .join(", ");
    container.textContent = text || noBreakSpace;
    container.title = text;
  };

  const cellEditFileUploader = (cellInfo) => (
    <FileUploader
      selectButtonText="Select file"
      uploadMode="uploadUrl"
      multiple={true}
      accept="*"
      labelText="Max. File Size 4 MB"
      maxFileSize={4000000}
      onValueChanged={(e) => {
        cellInfo.data.setValue(e.value);
      }}
      allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
    />
  );

  const renderFileContent = () => {
    return (
      <>
        {popUpImages.lsImageName.map((moreInfo, i) => {
          return (
            <div className="d-flex justify-content-between">
              <div
                className="file-name pointer"
                style={{ width: "90%" }}
                onClick={() => {
                  getTypeOfFile(
                    {
                      imageName: moreInfo,
                      fileExtension: moreInfo.split(".")[1],
                    },
                    "MOC"
                  );
                }}
              >
                {moreInfo}
              </div>
              <>
                <i
                  title="Download"
                  className="fa fa-download pointer"
                  onClick={() => onDownloadFile(moreInfo, "MOC")}
                ></i>
              </>
            </div>
          );
        })}
      </>
    );
  };

  const togglePopup = (mocData) => {
    setIsPopupVisibility(true);
    const currentData = mocData.row.data;
    setmocRowData({
      id: currentData.mocid,
      existingID: currentData.existingMOCID,
      change: currentData.changes,
      mocDescription: currentData.description,
      mocInitiator: peopleList.find((a) => a.id === currentData.initiator)
        .employeeName,
      mocStatus: currentData.status,
    });
  };

  const onFileDel = (d) => {
    let deletedItems = [...delList];
    deletedItems.push(d);
    setDeleted(deletedItems);
  };

  const hidePopUp = () => {
    setIsPopupVisibility(false);
  };
  const exportData = () => {
    actions.exportData("digitaltier/exportMOCDetails", "Honeywell MOC", {
      siteId: siteId,
      tierId: tierId,
      widgetId: "",
      isAll: exportFilter == 1 ? false : true,
      startDate: moment(sDate).format("DD/MM/YYYY"),
      endDate: moment(eDate).format("DD/MM/YYYY"),
    });
  };
  const ViewAttachment = (cellInfo) => (
    <ViewFiles
      files={cellInfo.data.value}
      folderName="MOC"
      moreInfo={cellInfo}
      onRowUpdated={onFileDel}
      updateData={(e) => {
        cellInfo.data.setValue(e);
      }}
    />
  );

  //Start -User preference
  const handlePropertyChange = (e) => {
    setGridWidthPrefs(e, widgetId);
    // setGridUserPrefs(e, widgetId)
  };

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=${tierId}&SiteUID=${siteId}&widgetID=${widgetId}`
    );
    return () => {
      actions.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId: siteId,
          tierId: tierId,
          moduleName: widgetId,
          loggedinUser,
          prefSess: "userPref",
          GRID_COL_DEF,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPref) set("userPref", userPref);
    if (
      mocDataGridRef &&
      mocDataGridRef.current &&
      mocDataGridRef.current.instance !== null &&
      userPref &&
      mocData
    ) {
      applyUserPref(mocDataGridRef, userPref);
    }
  }, [mocData, peopleList, userPref]);
  // End -User preference

  const validateFiles = (e) => {
    const imageData = e?.newData?.imageName
      ? e.newData.imageName
      : e?.data?.imageName;
    // Check files are valid or not
    const validateUploadFiles = checkUploadFilesValid(
      imageData,
      ALLOWED_MIME_TYPES
    );

    if (validateUploadFiles.length) {
      const alertMsg = validateUploadFiles.map(
        (file) => `${file.name} - ${file.reason}`
      );
      alert(alertMsg.join("<br/>"), "Alert");
      e.cancel = true;
    }
  };

  return (
    <>
      {peopleList && (
        <>
          <DataGrid
            ref={mocDataGridRef}
            dataSource={mocData}
            showBorders={true}
            onContentReady={(e) => setGridUserPrefs(e, widgetId)}
            onColumnsChange={(e) => setGridWidthPrefs(e, widgetId)}
            repaintChangesOnly={true}
            onOptionChanged={handlePropertyChange}
            onCellPrepared={function (e) {
              if (
                e.rowType === "filter" &&
                (e.column.dataField === "changes" ||
                  e.column.dataField === "status" ||
                  e.column.dataField === "initiator" ||
                  e.column.dataField === "initiator")
              )
                e.cellElement.firstChild.style.display = "none";
            }}
            {...GRID_CONFIG}
            {...handlers}
            onRowUpdating={validateFiles}
            onRowInserting={validateFiles}
          >
            <ColumnFixing enabled={true} />
            <Paging defaultPageSize={10} />
            <Pager
              visible={true}
              allowedPageSizes={[5, 10, 20, 50]}
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true}
            />
            <Editing
              mode="popup"
              allowUpdating={isEditable}
              allowAdding={isEditable}
              allowDeleting={isEditable}
              useIcons={true}
            >
              <Popup title="MOC" showTitle={true} width={800} />
            </Editing>
            <Export enabled={true} />
            <ColumnChooser enabled={true} mode="select" allowSearch={true} />
            <Toolbar>
              <Item name="refreshButton" />
              <Item location="after" name="addRowButton"></Item>
              <Item location="after">
                <Button1 icon="export" onClick={exportData} />
              </Item>
              <Item name="columnChooserButton" />
              <Item name="searchPanel" />
            </Toolbar>
            <Column
              dataField="mocid"
              dataType="number"
              visible={false}
              showInColumnChooser={true}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column
              dataField="existingMOCID"
              caption="Existing MOC ID"
              dataType="string"
            >
              <FormItem colSpan={2} />
            </Column>
            <Column
              dataField="changes"
              caption="Changes"
              cssClass="WrappedColumn"
              allowSorting={false}
              editCellComponent={TagBoxToGrid}
              cellTemplate={cellTemplate}
            >
              <Lookup dataSource={changesList} />
              <FormItem colSpan={2} />
              <RequiredRule />
            </Column>
            <Column
              dataField="description"
              caption="Description"
              dataType="string"
              cssClass="WrappedColumn"
            >
              <FormItem editorType="dxTextArea" colSpan={2} />
              <RequiredRule />
            </Column>
            <Column
              dataField="comments"
              caption="Comments"
              dataType="string"
              showInColumnChooser={true}
            >
              <FormItem editorType="dxTextArea" colSpan={2} />
            </Column>

            <Column dataField="status" caption="Status" dataType="string">
              <FormItem
                editorType="dxRadioGroup"
                colSpan={2}
                editorOptions={{ layout: "horizontal" }}
              />
              <Lookup dataSource={hseStatus} />
              <RequiredRule />
            </Column>
            <Column
              dataField="initiator"
              caption="Change Initiator"
              dataType="string"
            >
              <Lookup
                dataSource={peopleList}
                valueExpr="id"
                displayExpr="employeeName"
              />
              <RequiredRule />
              <FormItem colSpan={2} />
            </Column>
            <Column
              dataField="dueDate"
              caption="Due Date"
              dataType="date"
              editorOptions={{ useMaskBehavior: true }}
              cssClass="WrappedColumn"
            >
              <RequiredRule />
              <FormItem editorType="dxDateBox" width={90} colSpan={2} />
            </Column>
            <Column
              dataField="createdOn"
              caption="Created Date"
              dataType="date"
              editorOptions={{ useMaskBehavior: true }}
              cssClass="WrappedColumn"
              allowAdding={false}
              allowEditing={false}
            >
              <FormItem
                editorType="dxDateBox"
                width={90}
                colSpan={2}
                //visible={false}
              />
            </Column>
            <Column
              {...{
                dataField: "lsImageName",
                caption: "Attachments",
                allowEditing: true,
                editorOption: { allowEditing: true },
                visible: false,
              }}
              editCellComponent={ViewAttachment}
              cellRender={cellRender}
            >
              <FormItem colSpan={2} />
            </Column>
            <Column
              {...{
                dataField: "imageName",
                caption: "Upload Attachments",
                allowEditing: true,
                editorOption: { allowEditing: true },
                visible: false,
              }}
              editCellComponent={cellEditFileUploader}
              cellRender={cellRender}
              showInColumnChooser={false}
            >
              <FormItem colSpan={2} />
            </Column>
            <Column
              fixedPosition="right"
              fixed={true}
              type="buttons"
              id="popup"
              showInColumnChooser={false}
            >
              <Button
                name="view"
                hint="View Details"
                icon="info"
                onClick={(e) => {
                  togglePopup(e);
                }}
              />
              <Button name="edit"></Button>
              <Button name="delete"></Button>
            </Column>
          </DataGrid>

          {isPopupVisible && (
            <Popup
              mode="popup"
              width={500}
              height={300}
              showTitle={true}
              title={"View MOC Details"}
              dragEnabled={false}
              hideOnOutsideClick={true}
              onHiding={hidePopUp}
              visible={isPopupVisible}
            >
              <ScrollView id="scrollview" {...scrollConfig}>
                <div class="row">
                  <div class="col4">
                    <div>
                      <label className="view-grid-info"> Changes :</label>
                      <span> {mocRowData.change} </span>
                    </div>
                    <br />
                    <br />
                    <div>
                      <label className="view-grid-info">
                        {" "}
                        Existing MOC ID :
                      </label>
                      <span> {mocRowData.existingID} </span>
                    </div>

                    <br />
                    <br />
                    <div>
                      <label className="view-grid-info"> Description :</label>
                      <span> {mocRowData.mocDescription} </span>
                    </div>
                    <br />
                    <br />
                  </div>
                  <div class="col4">
                    <div>
                      <label className="view-grid-info">
                        {" "}
                        Change Initiator :
                      </label>
                      <span> {mocRowData.mocInitiator} </span>
                    </div>
                    <br />
                    <br />
                    <div>
                      <label className="view-grid-info"> Comments :</label>
                      <span> {mocRowData.comments} </span>
                    </div>
                  </div>
                </div>
              </ScrollView>
            </Popup>
          )}

          {isFilePopupVisible && (
            <Popup
              width={500}
              height={500}
              showTitle={true}
              title={"Attachments"}
              dragEnabled={false}
              hideOnOutsideClick={true}
              onHiding={toggleFilePopup}
              visible={isFilePopupVisible}
              contentRender={renderFileContent}
            ></Popup>
          )}
        </>
      )}
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </>
  );
};
